import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { adminSummaryAPI } from '../../api/admin';
import { passwordChangeAPI } from '../../api/login';
import { Card, Empty, Field, Input, Btn, Row, Grid, Msg } from './ui';
import tokens from '../theme/tokens';

// 대시보드 — 회원·접수·문의·배너·공지 숫자 한눈에
const useStyles = makeStyles((theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: 14,
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
  },
  stat: {
    padding: '18px 20px',
    borderRadius: 16,
    backgroundColor: tokens.surface,
    boxShadow: '0 4px 16px rgba(22, 22, 23, 0.06)',
    '& small': { display: 'block', fontSize: 13, color: tokens.muted, letterSpacing: -0.4 },
    '& b': { display: 'block', marginTop: 8, fontSize: 28, fontWeight: 700, letterSpacing: -1, color: tokens.ink },
    '& em': { display: 'block', marginTop: 4, fontStyle: 'normal', fontSize: 12, color: tokens.primaryDark },
  },
}));

// 관리자 비밀번호 변경 — 전달받은 초기 비밀번호를 여기서 바꾼다
function PasswordCard({ me }) {
  const [form, setForm] = useState({ currentPassword: '', password: '', password1: '' });
  const [msg, setMsg] = useState({ ok: false, text: '' });
  const [busy, setBusy] = useState(false);
  if (!me || me.userJoinType !== 'Email') return null;
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = async () => {
    if (form.password !== form.password1) { setMsg({ ok: false, text: '새 비밀번호가 일치하지 않습니다.' }); return; }
    setBusy(true); setMsg({ ok: false, text: '' });
    const resp = await passwordChangeAPI(form);
    setBusy(false);
    if (resp && resp.status === 200) { setForm({ currentPassword: '', password: '', password1: '' }); setMsg({ ok: true, text: '비밀번호를 바꿨습니다.' }); }
    else setMsg({ ok: false, text: (resp && resp.data && resp.data.message) || '바꾸지 못했습니다.' });
  };
  return (
    <Card title="내 비밀번호 변경" desc={me.email}>
      <Grid cols={3}>
        <Field label="현재 비밀번호"><Input type="password" autoComplete="current-password" value={form.currentPassword} onChange={set('currentPassword')} /></Field>
        <Field label="새 비밀번호 (영문·숫자·특수문자 8~16자)"><Input type="password" autoComplete="new-password" value={form.password} onChange={set('password')} /></Field>
        <Field label="새 비밀번호 확인"><Input type="password" autoComplete="new-password" value={form.password1} onChange={set('password1')} /></Field>
      </Grid>
      <Row><Btn onClick={save} disabled={busy || !form.currentPassword || !form.password}>{busy ? '변경 중' : '변경'}</Btn><Msg ok={msg.ok}>{msg.text}</Msg></Row>
    </Card>
  );
}

function AdminSummary({ onSelect, me }) {
  const cs = useStyles();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    adminSummaryAPI().then((resp) => {
      if (resp && resp.status === 200) setData(resp.data);
      else setError((resp && resp.data && resp.data.message) || '불러오지 못했습니다.');
    });
  }, []);

  if (error) return <Card><Empty>{error}</Empty></Card>;
  const d = data || {};
  const stats = [
    { key: 'members', label: '회원', value: d.members, sub: d.membersToday ? `오늘 +${d.membersToday}` : '' },
    { key: 'orders', label: '홈페이지 접수', value: d.orders, sub: d.ordersToday ? `오늘 +${d.ordersToday}` : '' },
    { key: 'chats', label: '답변 대기 문의', value: d.chatsWaiting, sub: '실시간문의' },
    { key: 'banners', label: '노출 중 배너', value: d.banners, sub: d.noticeEnabled ? '공지 켜짐' : '공지 꺼짐' },
  ];
  return (
    <React.Fragment>
      <div className={cs.grid}>
        {stats.map((s) => (
          <div key={s.key} className={cs.stat} role="button" tabIndex={0} onClick={() => onSelect(s.key === 'chats' ? 'summary' : s.key)}>
            <small>{s.label}</small>
            <b>{data ? Number(s.value || 0).toLocaleString('ko-KR') : '-'}</b>
            {s.sub && <em>{s.sub}</em>}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 16 }}><PasswordCard me={me} /></div>
    </React.Fragment>
  );
}

export default AdminSummary;
